import { useEffect, useState } from 'react';

const PHONE_1 = '05423031936';
const PHONE_2 = '05527551936';
const PHONE_1_DISPLAY = '0542 303 19 36';
const PHONE_2_DISPLAY = '0552 755 19 36';

export default function TopBar() {
  const [visible, setVisible] = useState(true);
  const [lastY, setLastY] = useState(0);

  useEffect(() => {
    const handler = () => {
      const y = window.scrollY;
      setVisible(y < lastY || y < 80);
      setLastY(y);
    };
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, [lastY]);

  return (
    <div
      className={`w-full bg-[#1a1a1a] text-white transition-all duration-300 z-50 ${
        visible ? 'translate-y-0' : '-translate-y-full'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-col md:flex-row items-center justify-between gap-2 text-sm">
        {/* Left */}
        <div className="flex items-center gap-3 flex-wrap justify-center md:justify-start">
          <span className="flex items-center gap-1 border border-emerald-500 text-emerald-400 px-3 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap">
            <i className="ri-medal-line text-xs" /> 18 Yıllık Tecrübe
          </span>
          <span className="text-gray-300 text-xs hidden md:block whitespace-nowrap">
            <i className="ri-map-pin-line mr-1 text-emerald-400" />
            Anadolu &amp; Avrupa Yakası&apos;na Hizmet Veriyoruz
          </span>
          {/* Social icons */}
          <div className="hidden md:flex items-center gap-2 ml-1">
            <a
              href="https://www.instagram.com/temizlik.firsati/"
              target="_blank"
              rel="nofollow noreferrer"
              title="Instagram"
              className="w-6 h-6 flex items-center justify-center text-gray-400 hover:text-pink-400 transition-colors"
            >
              <i className="ri-instagram-line text-sm" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61559750281545"
              target="_blank"
              rel="nofollow noreferrer"
              title="Facebook"
              className="w-6 h-6 flex items-center justify-center text-gray-400 hover:text-blue-400 transition-colors"
            >
              <i className="ri-facebook-fill text-sm" />
            </a>
          </div>
        </div>

        {/* Right - Phone Numbers */}
        <div className="flex items-center gap-4 flex-wrap justify-center">
          <a
            href={`tel:${PHONE_1}`}
            className="flex items-center gap-1.5 font-semibold text-white hover:text-emerald-400 transition-colors whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-emerald-400 text-sm" />
            </span>
            {PHONE_1_DISPLAY}
          </a>
          <span className="text-gray-600 hidden md:block">|</span>
          <a
            href={`tel:${PHONE_2}`}
            className="flex items-center gap-1.5 font-semibold text-white hover:text-emerald-400 transition-colors whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-emerald-400 text-sm" />
            </span>
            {PHONE_2_DISPLAY}
          </a>
        </div>
      </div>
    </div>
  );
}

export { PHONE_1, PHONE_2, PHONE_1_DISPLAY, PHONE_2_DISPLAY };
